import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Gauge } from "lucide-react";

interface IFurnaceVentSize {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

/**
 * Consolidated Furnace Vent / Cap / Collar size selector.
 * Replaces the old FurnaceVentJackSize + FurnaceVentCapCollar pair.
 * Since the jack and cap/collar are always the same size, one field is sufficient.
 */
export function FurnaceVentSize(props: IFurnaceVentSize) {
    const { value, onChange, loading } = { ...props };
    const [size, setSize] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setSize(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setSize(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Furnace Vent / Cap / Collar
            </Typography>

            <Select
                placeholder="Select size"
                value={size}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Gauge size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="4 inch">4 inch</Option>
                <Option value="5 inch">5 inch</Option>
                <Option value="6 inch">6 inch</Option>
                <Option value="7 inch">7 inch</Option>
                <Option value="TBD">TBD</Option>
            </Select>
        </Box>
    );
}
